import { Field } from 'formik';
import styled from 'styled-components/macro';

export const CounterWrapper = styled.div<{
  disabled?: boolean;
  width?: string;
  counterFieldWithBorder?: boolean;
}>`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: ${({ disabled }) => (disabled ? 'center' : 'space-between')};

  ${({ theme, counterFieldWithBorder }) =>
    counterFieldWithBorder &&
    `
  border: 1px solid ${theme.colors.black_20};
  border-radius: ${theme.spacing.zero_2};
  padding: ${theme.spacing.zero_2} ${theme.spacing.one};
`}

  width: ${({ width }) => width || '100%'};
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    width: 100%;
  }
`;

export const IconWrapper = styled.div<{ disabled?: boolean; counterFieldWithBorder?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 2rem;
  height: 2rem;
  border-radius: 2rem;

  background-color: ${({ theme, counterFieldWithBorder }) =>
    counterFieldWithBorder ? 'none' : theme.colors.black_5};

  cursor: pointer;
  :hover {
    svg > {
      stroke: ${({ disabled, theme }) => (disabled ? '' : theme.colors.black_80)};
    }
  }
`;

export const CounterInput = styled(Field)`
  width: 2rem;
  min-width: 2rem;

  border: none;

  color: ${({ theme }) => theme.colors.black_100};
  font-size: ${({ theme }) => theme.fontSize.xs};
  text-align: center;
`;

export const Description = styled.span`
  color: ${({ theme }) => theme.colors.black_100};
  font-size: ${({ theme }) => theme.fontSize.xs};

  user-select: none;
`;
